var map = {
	"./ana-icon.webp": 20,
	"./ana.webp": 88,
	"./ashe.webp": 89,
	"./baptiste-icon.webp": 21,
	"./baptiste.webp": 90,
	"./bastion-icon.webp": 22,
	"./bastion.webp": 91,
	"./bob-icon.webp": 23,
	"./bob.webp": 92,
	"./brigitte.webp": 93,
	"./card-back.webp": 35,
	"./doomfist.webp": 94,
	"./dva.webp": 95,
	"./dvameka.webp": 96,
	"./echo.webp": 97,
	"./genji.webp": 98,
	"./hanzo-icon.webp": 24,
	"./hanzo.webp": 99,
	"./junkrat.webp": 100,
	"./lucio-icon.webp": 25,
	"./lucio.webp": 101,
	"./mccree.webp": 102,
	"./mei-icon.webp": 26,
	"./mei.webp": 103,
	"./mercy-icon.webp": 15,
	"./mercy.webp": 104,
	"./moira.webp": 105,
	"./orisa-icon.webp": 27,
	"./orisa.webp": 106,
	"./pharah.webp": 107,
	"./reaper.webp": 108,
	"./reinhardt.webp": 109,
	"./roadhog.webp": 110,
	"./sigma-icon.webp": 28,
	"./sigma.webp": 111,
	"./soldier.webp": 112,
	"./sombra.webp": 113,
	"./symmetra.webp": 114,
	"./torbjorn-icon.webp": 29,
	"./torbjorn.webp": 115,
	"./tracer.webp": 116,
	"./widowmaker-icon.webp": 30,
	"./widowmaker.webp": 117,
	"./winston.webp": 118,
	"./wreckingball-icon.webp": 31,
	"./wreckingball.webp": 119,
	"./zarya-icon.webp": 32,
	"./zarya.webp": 120,
	"./zenyatta-icon.webp": 33,
	"./zenyatta.webp": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;